export const QUESTION_ANSWER_COMPLETE_EVENT = "question_answer_complete";

export type QuestionAnswerCompleteEventDetail = {
	questionId: string;
};

/** Delay before retrying summary fetch if LangChain has not written it yet. */
export const QUESTION_SUMMARY_REFETCH_RETRY_MS = 1500;

/** Maximum summary fetch attempts after the first answer (initial + retries). */
export const QUESTION_SUMMARY_REFETCH_MAX_ATTEMPTS = 6;
